/**
 * AUTH0
 */
export const AUTH0_CLIENT_ID =
  import.meta.env.VITE_REACT_APP_AUTH0_CLIENT_ID ||
  '6l6MSQViQQjaBmmE9pkXSxw6uiVOSGYM'
export const AUTH0_DOMAIN =
  import.meta.env.VITE_REACT_APP_AUTH0_DOMAIN || 'devicebits-demo.auth0.com'

export const SEARCH_API_URL = import.meta.env.VITE_REACT_APP_SEARCH_API_URL

/**
 * App's Web Storage keys in UTF-16 string format
 * stored in sesssionStorage or localStorage
 */
export const URL_BEFORE_LOGOUT = 'urlBeforeLogout'
export const JWT_TOKEN = 'id_token'
export const ACCESS_TOKEN = 'access_token'
export const AUTH_USER_ID = 'user_id'
export const AUTH_USER_EMAIL = 'user_email'
export const APP_INSTANCE_ID = 'app_instance_id'
export const CALL_SESSION_ID = 'call_session_id'
export const MANAGEMENT_API_TOKEN = 'management_api_token'

/**
 * App's named keys stored in Cookies
 */
export const DEVICE_ID = 'deviceId'
export const DEVICE_OS = 'deviceOs'
export const USER_ID = 'user_id' // aka permanentId
export const SESSION_ID = 'session_id'

/**
 * GA
 */
export const ANALYTICS_ID = 'UA-71383119-3'
